import { render, staticRenderFns } from "./mensageria.vue?vue&type=template&id=835ca222&scoped=true"
import script from "./mensageria.vue?vue&type=script&lang=js"
export * from "./mensageria.vue?vue&type=script&lang=js"
import style0 from "./mensageria.vue?vue&type=style&index=0&id=835ca222&prod&lang=css"
import style1 from "./mensageria.vue?vue&type=style&index=1&id=835ca222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835ca222",
  null
  
)

export default component.exports